import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { TRANSCRIPT_ROUTES } from "TranscriptsV3/modules/constants";

export default store => ({
  path: `${TRANSCRIPT_ROUTES.SCHOOLS}/:schoolId(/:yearGroupId)`,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-school-details" */ "./components"
    ).then(m => m.default)
  ),
});
